// تعديل حركة — بما فيها التاريخ.
//
// بلا تاريخ قابل للتعديل يستحيل تصحيح «نسيت أن أسجّل يوم الثلاثاء»، فتُنسب كل
// الحركات إلى يوم التسجيل وتكذب التقارير عن أي يوم صُرف المال.
// والحذف بلا سؤال تأكيد، مع تراجع: التأكيد يبطئ كل عمليات الحذف ليحمي من خطأ نادر.

import { esc, ymd, fromYmd, startOfDay } from '../util.js';
import { state, updateEntry, removeEntry, CURRENCIES } from '../store.js';
import { calcBox, sentence, destStrip, typeStrip, keypad, backBar } from '../ui.js';
import { noteField } from './entry.js';
import * as calc from '../calc.js';

export function draftFrom(id){
  const e = state.entries.find(x => x.id === id);
  if (!e) return null;
  return {
    id: e.id,
    calc: calc.fromNumber(e.amount),
    destId: e.destId,
    typeId: e.typeId,
    currency: e.currency,
    kind: e.kind,
    date: ymd(new Date(e.occurredAt).getTime()),
    originalTs: new Date(e.occurredAt).getTime(),
    // الملاحظة تُفتح مكتوبةً إن كانت للحركة ملاحظة — فمن جاء ليعدّلها يراها
    note: e.note || '',
    noteOpen: !!e.note
  };
}

export function render(app){
  const d = app.editDraft;
  if (!d) return backBar('تعديل', 'الحركة غير موجودة');
  const income = d.kind === 'in';
  const total = calc.value(d.calc);
  const ready = total !== null && total > 0 && d.destId;

  return backBar('تعديل الحركة', 'المبلغ والوجهة والنوع والتاريخ')
    + calcBox(d.calc, d.currency, sentence(d.destId, d.typeId), income)
    + '<div class="midscroll">'
    +   `<div class="dates" style="padding-top:6px">
          <label>تاريخ الحركة<input type="date" id="editDate" value="${esc(d.date)}"></label>
        </div>`
    +   destStrip(d.destId, { addBtn: false })
    +   (income ? '' : typeStrip(d.typeId, { addBtn: false, hint: 'اختياري' }))
    + '</div>'
    + keypad()
    + noteField(d)
    + `<button type="button" class="cta" data-act="saveedit" ${ready ? '' : 'disabled'}>حفظ التعديل</button>`
    + `<div class="linkrow">
        <button type="button" class="cta danger" data-act="delete"
          style="margin:0;padding:11px;font-size:13px;border:0">حذف الحركة</button>
        <button type="button" data-act="back">إلغاء</button>
      </div>`;
}

export function mount(app, root){
  const inp = root.querySelector('#editDate');
  if (inp) inp.addEventListener('change', () => { app.editDraft.date = inp.value; });

  // كما في شاشة التسجيل: لا إعادة رسمٍ عند الكتابة، فلا يضيع التركيز
  const box = root.querySelector('#entryNote');
  if (!box) return;
  const cnt = root.querySelector('.notefield .cnt');
  box.oninput = () => {
    app.editDraft.note = box.value;
    if (cnt) cnt.textContent = `${box.value.length} / 500`;
  };
}

export function onClick(app, btn){
  const d = app.editDraft;
  if (!d) return;

  if (btn.dataset.act === 'note-open'){ d.noteOpen = true; return app.render(); }
  if (btn.dataset.act === 'note-clear'){ d.note = ''; d.noteOpen = false; return app.render(); }

  if (btn.dataset.key){ d.calc = calc.press(d.calc, btn.dataset.key); return app.render(); }
  if (btn.dataset.cur){ d.currency = btn.dataset.cur; return app.render(); }
  if (btn.dataset.dest){ d.destId = btn.dataset.dest; return app.render(); }
  if (btn.dataset.type){ d.typeId = d.typeId === btn.dataset.type ? null : btn.dataset.type; return app.render(); }

  const act = btn.dataset.act;

  if (act === 'calc'){
    return app.openCalc(calc.value(d.calc), v => {
      d.calc = calc.fromNumber(v);
      app.render();
    });
  }

  if (act === 'saveedit'){
    const amount = calc.value(d.calc);
    if (amount === null || amount <= 0 || !d.destId) return;
    const dayTs = fromYmd(d.date);
    let occurredAt = d.originalTs;
    if (dayTs != null && startOfDay(dayTs) !== startOfDay(d.originalTs)){
      // نحتفظ بساعة الحركة الأصلية عند تغيير اليوم فقط
      const old = new Date(d.originalTs);
      const nd = new Date(dayTs);
      nd.setHours(old.getHours(), old.getMinutes(), 0, 0);
      occurredAt = nd.getTime();
    }
    updateEntry(d.id, {
      amount, destId: d.destId, typeId: d.typeId,
      currency: d.currency, occurredAt: new Date(occurredAt),
      note: (d.note || '').trim()
    });
    app.editDraft = null;
    app.closeSub();
    app.toast('حُفظ التعديل');
    app.queueSync();
    return;
  }

  if (act === 'delete'){
    const gone = removeEntry(d.id);
    app.editDraft = null;
    app.closeSub();
    app.toast('حُذفت الحركة', 'تراجع', () => { if (gone) app.restore([gone]); });
    app.queueSync();
    return;
  }
  return false;
}
